import angular from 'angular';

import ErrorsModel from '../models/errors';

function ErrorFeedback(Errors, $q) {
	return {
		request: function (config) {
			// for all non-GET calls, clear out the messages for the URL
			// in the status messages object.  The thinking here is that
			// validation errors were probably populated for a prior
			// POST/PUT/DELETE to the same URL so on resubmit we want to
			// just clear out those messages and start fresh.
			if (config.method !== 'GET') {
				delete Errors.data[config.url];
			}
			return config;
		},
		responseError: function (response) {
			switch (response.status) {
			case 402:
				Errors.data[response.config.url] = response.data;
				break;
			case 403:
				Errors.data[response.config.url] = {
					error: "Permission error",
					details: "You do not have access to that functionality at the moment."
				};
				break;
			case 422:
				Errors.data[response.config.url] = response.data;
				break;
			case 500:
				Errors.data[response.config.url] = {
					error: "There seems to be a problem.  Please try again."
				};
				break;
			}
			return $q.reject(response);
		}
	};
}

ErrorFeedback.$inject = ['Errors', '$q'];
export default angular.module('interceptors.error-feedback', [ErrorsModel])
	.factory('ErrorFeedback', ErrorFeedback)
	.name;



// WEBPACK FOOTER //
// ./project/interceptors/error-feedback.js